<template>
  <MgdSidebarGroup>
    <MgdSidebarGroupLabel v-if="group.label">
      <Icon :name="group.label.icon" class="me-2" />
      {{ group.label.title }}
    </MgdSidebarGroupLabel>
    <MgdSidebarMenu>
      <MgdSidebarMenuItem v-for="item in displayableNavItems" :key="item.title">
        <span
          v-if="item.notification"
          class="absolute flex size-3 transition-[top,right,translate]"
          :class="{
            'top-1/2 right-2 -translate-y-1/2': state !== 'collapsed',
            'top-0.5 right-0': state === 'collapsed',
          }"
        >
          <span
            class="bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
          ></span>
          <span class="bg-primary inline-flex size-3 rounded-full"></span>
        </span>
        <MgdSidebarMenuButton
          v-if="'to' in item"
          :tooltip="item.title"
          as-child
          :is-active="
            item.isActive === 'startsWith'
              ? route.path.startsWith(item.to)
              : route.path === item.to
          "
        >
          <NuxtLink :to="item.to" @click="onClickNavItemLink()">
            <Icon :name="item.icon" />
            {{ item.title }}
          </NuxtLink>
        </MgdSidebarMenuButton>
        <MgdSidebarMenuButton
          v-else
          :tooltip="item.title"
          :is-active="item.isActive?.value === true"
          class="cursor-pointer"
          @click="onClickNavItemAction(item)"
        >
          <Icon :name="item.icon" />
          {{ item.title }}
        </MgdSidebarMenuButton>
      </MgdSidebarMenuItem>
    </MgdSidebarMenu>
  </MgdSidebarGroup>
</template>

<script setup lang="ts">
import { useSidebar } from "../ui/sidebar";

const props = defineProps<{ group: NavGroup }>();

export interface BaseNavItem {
  title: string;
  icon: string;
  hidden?: boolean;
  notification?: boolean;
}
export interface NavItemLink extends BaseNavItem {
  to: string;
  isActive: "startsWith" | "equals";
}
export interface NavItemAction extends BaseNavItem {
  click: () => unknown;
  isActive?: Ref<boolean>;
}
export type NavItem = NavItemLink | NavItemAction;
export interface NavGroup {
  label?: { icon: string; title: string };
  items: (NavItem | false)[];
}
const route = useRoute();
const displayableNavItems = computed<NavItem[]>(() =>
  props.group.items.filter((i): i is NavItem => i && i.hidden !== true),
);
const { isMobile, setOpenMobile, state } = useSidebar();

function onClickNavItemAction(item: NavItemAction) {
  if (isMobile.value) {
    setOpenMobile(false);
  }
  item.click();
}
function onClickNavItemLink() {
  if (isMobile.value) {
    setOpenMobile(false);
  }
}
</script>
